
import { of as observableOf, Observable } from 'rxjs';

import { shareReplay, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';;
 


import { cloneDeep } from 'lodash';
import { Client } from 'app/customers/client.class';
import { LoggerService } from 'app/shared/service/logger/logger.service';
import { HttpClient } from '@angular/common/http';
import { setSessionData, getSessionData } from 'app/util';

@Injectable({
    providedIn: 'root'
})
export class ClientByAgeService {

  constructor(
    private logger: LoggerService,
    public http: HttpClient,
  ) { }
  // getAgeData(resetOpt = null) {

  //   let url = '/api/agents/graphByAgeData';
  //   if (resetOpt) {
  //     url = url + '?refresh=' + resetOpt
  //   }
  //   if (getSessionData('ageData')) {
  //     this.logger.log("getAgeData res: ", getSessionData('ageData'))
  //     return observableOf(cloneDeep(getSessionData('ageData')))
  //   }
  //   return this.http.post(url, {}).pipe(map(
  //     (res: any) => {
  //       this.logger.log("getAgeData res: ", res)
  //       setSessionData('ageData', res)
  //       return cloneDeep(getSessionData('ageData'))
  //     }
  //   ), shareReplay({bufferSize: 1,refCount: true}));
  //   // return this.http.get("/api/weeklyDatas/getpolicycountWeekly").pipe(map((res:any)=>res))
  // }
}
